export const isIphone = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPhone/i.test(userAgent);
};
